module.exports = __webpack_public_path__ + "img/floating.0a899068.jpg";